<template>
  <!-- Table Container Card -->
  <b-card id="page-users" no-body class="mb-0 p-2">
    <b-card-header
      class="pl-0 pr-0 d-flex align-items-between justify-content-center"
    >
      <b-col cols="12" md="4">
        <b-card-title
          ><h2>{{ $t(label("title")) }}</h2></b-card-title
        >
      </b-col>
      <b-col v-if="canCreate" cols="12" md="8" class="d-none d-md-table">
        <b-col cols="12" class="d-flex align-items-between justify-content-end">
          <b-button id="tooltip-create" variant="primary" @click="onCreate">
            <feather-icon
              aria-label="Register"
              icon="PlusIcon"
              class="mr-25"
              size="18"
            />
            <span class="text-nowrap">{{ $t(label("register")) }}</span>
          </b-button>
        </b-col>
      </b-col>
      <b-col
        v-if="canCreate"
        cols="12"
        sm="12"
        md="8"
        class="d-md-none d-flex justify-content-end pt-2"
      >
        <b-button
          id="tooltip-create"
          variant="primary"
          @click="onCreate"
          class="btn-icon"
        >
          <feather-icon icon="PlusIcon" size="18" aria-label="Register" />
        </b-button>
      </b-col>
      <b-tooltip
        placement="top"
        target="tooltip-create"
        triggers="hover"
        @click="onInfo"
      >
        <strong>
          <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
          Ver tutorial
        </strong>
        <span> </span>
      </b-tooltip>
    </b-card-header>

    <Filterss
      :fields="fildsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />

    <!-- Table for larger devices -->
    <b-table
      id="users-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>
      <template #cell(name)="data">
        <slot name="cell-name" :data="data">
          {{ data.item.name || "N/A" }}
        </slot>
      </template>

      <template #cell(lastName)="data">
        <slot name="cell-lastName" :data="data">
          {{ data.item.lastName || "N/A" }}
        </slot>
      </template>

      <template #cell(dni)="data">
        <slot name="cell-dni" :data="data">
          {{ data.item.dni || "N/A" }}
        </slot>
      </template>

      <template #cell(email)="data">
        <slot name="cell-email" :data="data">
          {{ data.item.email || "N/A" }}
        </slot>
      </template>

      <template #cell(phoneNumber)="data">
        <slot name="cell-phoneNumber" :data="data">
          {{ data.item.phoneNumber || "N/A" }}
        </slot>
      </template>

      <template #cell(actions)="data">
        <slot name="cell-actions" :data="data">
          <feather-icon
            v-if="canShow"
            class="text-success mr-25 cursor-pointer"
            aria-label="Show details"
            size="18"
            icon="FileTextIcon"
            @click="onShow(data.item.guid)"
          />
          <feather-icon
            v-if="canEdit"
            class="text-primary mr-25 cursor-pointer"
            aria-label="Edit details"
            size="18"
            icon="EditIcon"
            @click="onEdit(data.item.guid)"
          />
          <feather-icon
            class="text-danger cursor-pointer"
            aria-label="Delete details"
            size="18"
            icon="Trash2Icon"
            @click="onDelete(data.item.guid)"
          />
        </slot>
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>

    <!-- pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" md="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">
              {{ $t("perPage") }}
            </label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.idClient"
          class="d-flex flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <strong>
              {{ $t(labelHeader("name")) }} : {{ item.name || "N/A" }}</strong
            >

            <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item v-if="canShow" @click="onShow(item.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-success mr-25 cursor-pointer"
                    aria-label="Show details"
                    size="18"
                    icon="FileTextIcon"
                  />
                  {{ $t("show") }}
                </div>
              </b-dropdown-item>
              <b-dropdown-item v-if="canEdit" @click="onEdit(item.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-primary mr-25 cursor-pointer"
                    aria-label="Edit details"
                    size="18"
                    icon="EditIcon"
                  />
                  {{ $t("edit") }}
                </div>
              </b-dropdown-item>
              <!-- <b-dropdown-item @click="onDelete(item.idClient)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-danger cursor-pointer"
                    aria-label="Delete details"
                    size="18"
                    icon="Trash2Icon"
                  />
                  {{ $t("delete") }}
                </div>
              </b-dropdown-item> -->
            </b-dropdown>
          </div>
          {{ item.name }} <br />
          {{ item.email != null ? item.email : "-" }}<br />
          {{ item.nameCompany != null ? item.nameCompany : "-" }} <br />
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading">
          <b-spinner variant="success"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>
<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BFormGroup,
  BCardGroup,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Filterss from "../components/filters/Filterss.vue";
import { deleteClient, allClientsByCompany } from "@core/api/request/clients";
import { allUsers, deleteUser } from "@core/api/request/user";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    Filterss,
    BCardGroup,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    "b-tooltip": BTooltip,
    Ripple,
  },
  data: () => ({
    model: "users",
    companyGuid: null,
    loading: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    fields: [
      { label: "name", key: "name", sortable: true },
      { label: "email", key: "email", sortable: true },
      { label: "name-company", key: "nameCompany", sortable: true },
      { label: "action", key: "actions", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        title: "name",
        placeholder: "name",
        type: "search",
        visible: true,
      },
    ],
    appliedFilters: {},
  }),

  computed: {
    canCreate() {
      return canAccess("Usuarios", "creation");
    },
    canShow() {
      return canAccess("Usuarios", "reading");
    },
    canEdit() {
      return canAccess("Usuarios", "edition");
    },
    canDelete() {
      return canAccess("Usuarios", "elimination");
    },
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.hasNextPage = true;
      this.currentPage = 1;
      this.items = [];
      this.loadData(guid);
    },
  },
  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadData();
  },
  mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const params = this.chargeParams();
        const [usersResp] = await Promise.all([allUsers(params)]);

        // Procesamos clientes
        const clients = _.get(usersResp, "data");
        this.items = clients?.items || [];
        this.totalRows = clients?.totalRows || 0;
        this.hasNextPage = clients?.currentPage < clients?.totalPages || 0;
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      } finally {
        this.loading = false;
      }
    },
    async loadUsersInfinity() {
      if (!this.hasNextPage) return;
      try {
        this.loading = true;
        const params = this.chargeParams();
        allUsers(params)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              // Agregar nuevos elementos sin sobreescribir los existentes
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            // Verificar si hay más páginas
            this.hasNextPage = data?.currentPage < data?.totalPages || false;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.error("Error loading products infinitely", error);
          });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error cargando productos infinitamente", error.message);
      }
    },
    label(field) {
      return `pages.users.table.${field}`;
    },
    labelHeader(field) {
      return `pages.users.table.tableHeader.${field}`;
    },
    chargeParams() {
      const arrParams = [];
      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);
      arrParams.push(`active,${true}`);

      if (this.companyGuid) {
        arrParams.push(`guidCompany,${this.companyGuid}`);
      }

      if (this.appliedFilters.name) {
        arrParams.push(`name,${this.appliedFilters.name}`);
      }

      return getParams(arrParams);
    },

    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadUsersInfinity();
      }
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadData();
    },

    handlePerPageChange() {
      this.loadData();
    },

    validateFilters(filters) {
      // Validar nombre (no debe ser vacío ni contener solo espacios)
      if (filters.name && !filters.name.trim()) {
        console.error("El filtro de nombre no es válido.");
        return false;
      }

      return true;
    },

    applyFilters(filters) {
      if (this.validateFilters(filters)) {
        this.appliedFilters = filters;
        this.currentPage = 1;
        this.hasNextPage = true;
        this.loadData();
      } else {
        console.error("Filtros no aplicados debido a validaciones fallidas.");
      }
    },

    resetFilters() {
      console.log("Resetting filters");
      this.appliedFilters = {};

      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },

    onCreate() {
      if (!this.canCreate) return;
      this.$router.push({
        name: "userCreate",
        params: { option: 1 },
      });
    },

    onShow(guid) {
      if (!this.canShow) return;
      this.$router.push({
        name: "userEdit",
        params: { option: 2, guid },
      });
    },

    onEdit(guid) {
      if (!this.canEdit) return;
      this.$router.push({
        name: "userEdit",
        params: { option: 3, guid },
      });
    },

    onDelete(idClient) {
      if (!this.canDelete) return;
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteUser(idClient)
            .then((resp) => {
              stopLoading();
              this.$swal({
                icon: "success",
                title: this.$t("Deleted"),
                text: this.$t("beenDeleted"),
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.loadData();
            })
            .catch((error) => {
              console.error("error", error.message);
              stopLoading();
              this.alertToast(
                "danger",
                this.$t("codeAlert"),
                error.message,
                "AlertTriangleIcon",
              );
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },

    onInfo() {},

    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss">
.per-page-selector {
  width: 90px;
}
.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
</style>
